import options from '~/components/Select/options';

export interface NotificationsFormValues {
  autoDeliveredEmailCustomText: Maybe<string>;
  autoDeliveredEmailNotifications: boolean;
  autoEmailNotifications: boolean;
  autoOrderEmailCustomText: Maybe<string>;
  autoOrderEmailDelayMinutes: Maybe<number>;
}

export enum NotificationType {
  Delivered = 'DELIVERED',
  Shipped = 'UNKNOWN',
}

export enum EmailSections {
  Branding = 'BRANDING',
  OrderArrived = 'ORDER_ARRIVED',
  OrderShipped = 'ORDER_SHIPPED',
}

type NotificationConfig = {
  DELIVERED?: DeliveredNotificationConfig;
  UNKNOWN?: ShippedNotificationConfig;
};

type ShippedNotificationConfig = {
  auto_email_delay_minutes: Maybe<number>;
  custom_text: Maybe<string>;
  is_auto_email_enabled: boolean;
};

type DeliveredNotificationConfig = {
  custom_text: Maybe<string>;
  is_auto_email_enabled: boolean;
};

export interface NotificationsPayload {
  notification_configs: NotificationConfig;
}

export interface OrderShippedFormFields {
  orderShippingEmailContent: string;
  orderShippingEmailDelaySendDuration: number;
  orderShippingEmailEnabled: boolean;
  orderShippingEmailSubject: string;
}

export interface OrderArrivedFormFields {
  orderArrivedEmailContent: string;
  orderArrivedEmailEnabled: boolean;
  orderArrivedEmailSubject: string;
}

export interface OrderArrivedReengagementFormFields {
  orderArrivedProductRecommendationsTitle: string;
  orderArrivedProductRecommendationsUrl1: string;
  orderArrivedProductRecommendationsUrl2: string;
  orderArrivedProductRecommendationsUrl3: string;
  orderArrivedProductRecommendationsUrl4: string;
  orderArrivedPromotionsUrl: string;
  orderArrivedSpotlightTitle: string;
  orderArrivedSpotlightUrl: string;
}

export const orderShippedFieldsToJSON = (
  orderShippedFormFields: OrderShippedFormFields,
): NotificationConfig => {
  const delayMinutes = +(orderShippedFormFields.orderShippingEmailDelaySendDuration || 0);
  // ensure the delay option exists before crafting the request data
  const foundOption = options.notificationOptions.find((option) => +option.value === delayMinutes);
  return {
    UNKNOWN: {
      auto_email_delay_minutes: foundOption ? delayMinutes : 0,
      custom_text: orderShippedFormFields.orderShippingEmailContent,
      is_auto_email_enabled: orderShippedFormFields.orderShippingEmailEnabled,
    },
  };
};

export const orderShippedFieldsFromJSON = (
  responseData: NotificationsPayload,
): OrderShippedFormFields => {
  const shippedConfig: Maybe<ShippedNotificationConfig> = responseData.notification_configs.UNKNOWN;
  return {
    orderShippingEmailContent: shippedConfig?.custom_text || '',
    orderShippingEmailDelaySendDuration: +(shippedConfig?.auto_email_delay_minutes || 0),
    orderShippingEmailEnabled: !!shippedConfig?.is_auto_email_enabled,
    orderShippingEmailSubject: '',
  };
};

export const orderArrivedFieldsToJSON = (
  orderArrivedFormFields: OrderArrivedFormFields,
): NotificationConfig => ({
  DELIVERED: {
    custom_text: orderArrivedFormFields.orderArrivedEmailContent,
    is_auto_email_enabled: orderArrivedFormFields.orderArrivedEmailEnabled,
  },
});

export const orderArrivedFieldsFromJSON = (
  responseData: NotificationsPayload,
): OrderArrivedFormFields => {
  const shippedConfig: Maybe<DeliveredNotificationConfig> =
    responseData.notification_configs.DELIVERED;
  return {
    orderArrivedEmailContent: shippedConfig?.custom_text || '',
    orderArrivedEmailEnabled: !!shippedConfig?.is_auto_email_enabled,
    orderArrivedEmailSubject: '',
  };
};
